// import React, { useState, useEffect } from 'react';
// import { jwtDecode } from 'jwt-decode';
// import { useHistory } from 'react-router-dom';
// import Table from '@mui/material/Table';
// import TableBody from '@mui/material/TableBody';
// import TableCell from '@mui/material/TableCell';
// import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
// import TableRow from '@mui/material/TableRow';
// import Paper from '@mui/material/Paper';
// import IconButton from '@mui/material/IconButton';
// import DeleteIcon from '@mui/icons-material/Delete';
// import EditIcon from '@mui/icons-material/Edit';
// import ArrowForward from '@mui/icons-material/ArrowForward';
// import ActivateIcon from '@mui/icons-material/CheckCircle';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import { fetchData, deleteData, activateData,postData } from '../../../apiService';
// import { Link } from 'react-router-dom';
// import { useAuth } from '../../../AuthContext';
// import { tokenIsExpired } from '../../../authUtils';
// import SearchIcon from '@mui/icons-material/Search';
// import Button from '@mui/material/Button';
// import CopyrightIcon from '@mui/icons-material/Copyright';
// import AddIcon from '@mui/icons-material/Add';
// import ImportExportIcon from '@mui/icons-material/ImportExport';
// import CircularProgress from '@mui/material/CircularProgress';
// import * as XLSX from 'xlsx';

// function ItemIndex() {
//     const [data, setData] = useState([]);
//     const [deleteItemId, setDeleteItemId] = useState(null);
//     const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
//     const [searchTerm, setSearchTerm] = useState('');
//     const history = useHistory(); // Access the navigation history
//     const [isLoading, setIsLoading] = useState(false);
//     const { isAuthenticated, companyId, branchId,userId, permissions, roleName, token, logout } = useAuth();
//     const hasCreateMasterPermission = permissions.includes('Create Master');
//     const hasEditMasterPermission = permissions.includes('Edit Master');
//     const hasDeleteMasterPermission = permissions.includes('Delete Master');

//     useEffect(() => {
//         // Check if the token is expired
//         if (isAuthenticated && tokenIsExpired(token)) {
//             // Token is expired, log out the user
//             logout();
//             return;
//         }

//         // Token is not expired, fetch data
//         fetchtableData();
//     }, [isAuthenticated, companyId, branchId, roleName, token, logout]);

//     const [searchQuery, setSearchQuery] = useState('');
//     const [showSearchInput, setShowSearchInput] = useState(false);
//     //handle search
//     const handleSearch = (event) => {
//         setSearchQuery(event.target.value);
//     };

//     const toggleSearchInput = () => {
//         setShowSearchInput(!showSearchInput);
//     };

//     //search
//     const filteredData = data.filter((item) =>
//         Object.values(item).some((value) =>
//             String(value).toLowerCase().includes(searchQuery.toLowerCase())
//         )
//     );

//     const fetchtableData = async () => {
//         fetchData('ItemApi', `/${companyId}`, token)
//             .then((response) => {
//                 if (response.responseCode === '1111') {
//                     setData(response.response_data);
//                     setFilteredData(response.response_data);
//                 }
//             })
//             .catch((error) => {
//                 console.error('Error fetching Item roup Details:', error);
//                 // Handle error, e.g., redirect to login if token is expired
//                 if (error.response && error.response.status === 401) {
//                     logout();
//                     // Redirect to login with the current location as a parameter
//                     history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
//                 }
//             });
//     };

//     const handleDelete = async () => {
//         deleteData('ItemApi', `${deleteItemId}`, token)
//             .then((response) => {
//                 fetchtableData();
//                 setDeleteItemId(null);
//                 setConfirmDialogOpen(false);
//             })
//             .catch((error) => {
//                 console.error('Error deleting record:', error);
//             });
//     };

//     const handleActivate = (itemId) => {
//         activateData('ItemApi', `${itemId}`, token)
//             .then(() => {
//                 fetchtableData();
//             })
//             .catch((error) => {
//                 console.error('Error activating record:', error);
//             });
//     };

//     const openConfirmDialog = (itemId) => {
//         setDeleteItemId(itemId);
//         setConfirmDialogOpen(true);
//     };

//     const closeConfirmDialog = () => {
//         setDeleteItemId(null);
//         setConfirmDialogOpen(false);
//     };

//     const [importDialogOpen, setImportDialogOpen] = useState(false);
//     const [fileData, setFileData] = useState([]);
//     const openImportDialog = () => {
//         setImportDialogOpen(true);
//     };

//     const closeImportDialog = () => {
//         setImportDialogOpen(false);
//         setFileData([]);
//     };

//     const handleFileChange = (event) => {
//         const file = event.target.files[0];
//         const reader = new FileReader();


//         reader.onload = (e) => {
//             const data = new Uint8Array(e.target.result);
//             const workbook = XLSX.read(data, { type: 'array' });
//             const firstSheetName = workbook.SheetNames[0];
//             const worksheet = workbook.Sheets[firstSheetName];
//             const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

//             const rowsToRead = sheetData.slice(5); // Read from the 5th row

//             const formattedData = rowsToRead
//                 .filter(row => row[2]) // Skip rows where row[2] (BillingDate) is blank
//                 .map((row) => {


//                     return {                        
//                         Material: row[0] ? String(row[0]) : "", 
//                         Description: row[1] ? String(row[1]) : "", 
//                         PG: row[2] ? String(row[2]) : "", 
//                         IG: row[3] ? String(row[3]) : "", 
//                         ISG: String(row[4]) , 
//                         PF: row[5] ? String(row[5]) : "", 
//                         Group: row[6] ? String(row[6]) : "", 
//                         HSN: row[8] ? String(row[8]) : "", 
//                         MIKCode: row[9] ? String(row[9]) : "", 
//                         GST: row[12] ?? 0,
//                         MRP: row[7] ?? 0,
//                         Category: row[11] ?? 0,

//                     };
//                 });

//             setFileData(formattedData);

//         };

//         reader.readAsArrayBuffer(file);
//     };

//     const handleImport = () => {

//         setIsLoading(true);

//         const CreateData = {
//             CompanyId: companyId,
//             BranchId: branchId,
//             CreatedBy: userId,
//             ItemImport: fileData
//         };

//         postData('ItemImportApi', CreateData, token)
//             .then((response) => {
//                 fetchtableData();
//                 setIsLoading(false);
//                 closeImportDialog();
//                 console.log('Data posted successfully:', response);
//             })
//             .catch((error) => {
//                 console.error('Error posting data:', error);
//                 setIsLoading(false);
//             });
//     };

//     function formatDate(dateString) {
//         const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
//         const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
//         return formattedDate;
//     }

//     return (
//         <div className="w-full max-w-sm container mt-2 mx-auto">
//             <div className='w-full mb-2 flex'>
//                 <h5 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item </h5>
//                 <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
//                     <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
//                     {showSearchInput && (
//                         <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
//                             type="text"
//                             placeholder="Search..."
//                             value={searchQuery}
//                             onChange={handleSearch}
//                             style={{ marginLeft: '-30px', width: '200px' }}
//                         />
//                     )}
//                 </div>


//                 {hasCreateMasterPermission && roleName == "SuperAdmin" && (
//                     <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
//                         <Button

//                             component={Link}
//                             to="/ItemCreate"
//                             className="linkcolor"
//                             style={{ marginLeft: '8px', color: 'orangered', fontWeight: 'bolder' }}
//                         >
//                             <AddIcon /> CREATE NEW
//                         </Button>
//                     </div>
//                 )}

//                 {hasCreateMasterPermission && (
//                     <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
//                         <Button

//                             onClick={openImportDialog}
//                             style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }}
//                         >
//                             <ImportExportIcon style={{ color: 'brown', fontWeight: 'bolder' }} />IMPORT ITEM
//                         </Button>
//                     </div>
//                 )}
//             </div>



//             <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
//                 <TableContainer component={Paper}>
//                     <Table>
//                         <TableHead sx={{ backgroundColor: '#58A5B3' }}>
//                             <TableRow>
//                                 <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '3%' }}>Sl.No</TableCell>
//                                 <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '10%' }}>Item Code</TableCell>
//                                 <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '45%' }}>Item Name</TableCell>
//                                 <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '10%' }}>MRP</TableCell>
//                                 <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '10%' }}>GST Rate</TableCell>
//                                 <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke', width: '10%' }}>HSN Code</TableCell>
//                                 <TableCell sx={{ borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '16px', padding: '7px', color: 'whitesmoke' }}>Actions</TableCell>
//                             </TableRow>
//                         </TableHead>

//                         <TableBody sx={{ backgroundColor: '#C3E9E4' }}>
//                             {data.map((item, index) => (
//                                 <TableRow key={item.id} className={item.IsActive ? '' : 'inactiveRow'}>
//                                     <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '3%', fontSize: '14px' }}>{index + 1}</TableCell>
//                                     <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.Code}</TableCell>
//                                     <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '45%', fontSize: '14px' }}>{item.Name}</TableCell>
//                                     <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.MRP}</TableCell>
//                                     <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.GSTRate}</TableCell>
//                                     <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.HSNCode}</TableCell>
//                                     <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>
//                                         {hasEditMasterPermission && (
//                                             <Link to={`/itemEdit/${item.Id}`}>
//                                                 <IconButton color="primary">
//                                                     <EditIcon style={{ height: '22px' }} />
//                                                 </IconButton>
//                                             </Link>
//                                         )}
//                                         {hasDeleteMasterPermission && (
//                                             <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))} color="error">
//                                                 {item.IsActive ? <DeleteIcon style={{ height: '22px' }} /> : <ActivateIcon style={{ color: 'darkolivegreen', height: '22px' }} />}
//                                             </IconButton>
//                                         )}

//                                     </TableCell>
//                                 </TableRow>
//                             ))}
//                         </TableBody>
//                         <Dialog
//                             open={confirmDialogOpen}
//                             onClose={closeConfirmDialog}
//                             aria-labelledby="alert-dialog-title"
//                             aria-describedby="alert-dialog-description"
//                         >
//                             <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
//                             <DialogContent>
//                                 <DialogContentText id="alert-dialog-description">
//                                     Are you sure you want to delete this record?
//                                 </DialogContentText>
//                             </DialogContent>

//                             <DialogActions>
//                                 <button
//                                     onClick={closeConfirmDialog}
//                                     style={{
//                                         backgroundColor: '#dc3545',
//                                         color: '#ffffff',
//                                         border: '1px solid #dc3545',
//                                         borderRadius: '4px',
//                                         padding: '8px 16px',
//                                         cursor: 'pointer',
//                                         marginRight: '8px',
//                                     }}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     onClick={handleDelete}
//                                     style={{
//                                         backgroundColor: '#28a745',
//                                         color: '#ffffff',
//                                         border: '1px solid #28a745',
//                                         borderRadius: '4px',
//                                         padding: '8px 16px',
//                                         cursor: 'pointer',
//                                     }}
//                                 >
//                                     Confirm
//                                 </button>
//                             </DialogActions>

//                         </Dialog>

//                         {/* Import Dialog */}
//                         <Dialog
//                             open={importDialogOpen}
//                             onClose={closeImportDialog}
//                             aria-labelledby="import-dialog-title"
//                             aria-describedby="import-dialog-description"
//                             maxWidth="lg"
//                             fullWidth
//                         >
//                             <DialogTitle id="import-dialog-title">Import Item</DialogTitle>
//                             <DialogContent>
//                                 <DialogContentText id="import-dialog-description">
//                                     Select an Excel file to import Item data. The data will be previewed before importing.
//                                 </DialogContentText>
//                                 <input
//                                     type="file"
//                                     accept=".xlsx, .xls"
//                                     onChange={handleFileChange}
//                                     style={{ marginTop: '16px' }}
//                                 />
//                                 {fileData.length > 0 && (
//                                     <TableContainer component={Paper}>
//                                         <Table>
//                                             <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
//                                                 <TableRow>
//                                                     {/* Add table headers for the preview data */}
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>Material</TableCell>
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>Description</TableCell>
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>PG</TableCell>
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>IG</TableCell>
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>ISG</TableCell>
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>PF</TableCell>
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>Group</TableCell>
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>MRP</TableCell>
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>HSN</TableCell>
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>MIK Code</TableCell>
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>GST %</TableCell>
//                                                     <TableCell sx={{ height: '30px', padding: '10px', borderBottom: '1px solid #ddd', width: '15%' }}>Category</TableCell>                                                    
//                                                 </TableRow>
//                                             </TableHead>
//                                             <TableBody>
//                                                 {fileData.map((row, index) => (
//                                                     <TableRow key={index}>                                                        
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.Material}</TableCell>
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.Description}</TableCell>
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.PG}</TableCell>
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.IG}</TableCell>
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.ISG}</TableCell>
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.PF}</TableCell>
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.Group}</TableCell>
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.MRP}</TableCell>
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.HSN}</TableCell>
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.MIKCode}</TableCell>
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.GST}</TableCell>
//                                                         <TableCell sx={{ height: '30px', padding: '5px', width: '15%' }}>{row.Category}</TableCell>                                                        
//                                                     </TableRow>
//                                                 ))}
//                                             </TableBody>
//                                         </Table>
//                                     </TableContainer>
//                                 )}
//                             </DialogContent>
//                             <DialogActions>
//                                 <Button
//                                     variant="contained"
//                                     onClick={closeImportDialog} color="primary">Cancel
//                                 </Button>

//                                 <Button variant="contained" onClick={handleImport} color="secondary" disabled={isLoading || fileData.length === 0}>
//                                     {isLoading ? <CircularProgress size={24} color="inherit" /> : "Import"}
//                                 </Button>
//                             </DialogActions>
//                         </Dialog>

//                     </Table>
//                 </TableContainer>
//             </div>
//             <div className="watermark">
//                 <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
//             </div>
//         </div>
//     );
// }

// export default ItemIndex;

import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import { Link, useHistory } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';

// Import react-window
import { FixedSizeList as List } from 'react-window';

function ItemIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [importDialogOpen, setImportDialogOpen] = useState(false);
    const [fileData, setFileData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, permissions, roleName, token, logout } = useAuth();

    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchtableData();
    }, [isAuthenticated, companyId, branchId, roleName, token, logout]);

    const fetchtableData = async () => {
        fetchData('ItemApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Item Group Details:', error);
                if (error.response && error.response.status === 401) {
                    logout();
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            });
    };

    const handleDelete = async () => {
        deleteData('ItemApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ItemApi', `${itemId}`, token)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const openImportDialog = () => {
        setImportDialogOpen(true);
    };

    const closeImportDialog = () => {
        setImportDialogOpen(false);
        setFileData([]);
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const rowsToRead = sheetData.slice(1);

            const formattedData = rowsToRead
                .filter(row => row[2])
                .map((row) => {
                    return {
                        Material: row[0] ? String(row[0]) : "",
                        Description: row[1] ? String(row[1]) : "",
                        PG: row[2] ? String(row[2]) : "",
                        IG: row[3] ? String(row[3]) : "",
                        ISG: String(row[4]),
                        PF: row[5] ? String(row[5]) : "",
                        Group: row[6] ? String(row[6]) : "",
                        HSN: row[8] ? String(row[8]) : "",
                        MIKCode: row[9] ? String(row[9]) : "",
                        GST: row[12] ?? 0,
                        MRP: row[7] ?? 0,
                        Category: row[11] ?? 0,
                    };
                });

            setFileData(formattedData);
        };

        reader.readAsArrayBuffer(file);
    };

    const handleImport = () => {
        setIsLoading(true);

        const CreateData = {
            CompanyId: companyId,
            BranchId: branchId,
            CreatedBy: userId,
            ItemImport: fileData
        };

        postData('ItemImportApi', CreateData, token)
            .then((response) => {
                fetchtableData();
                setIsLoading(false);
                closeImportDialog();
                console.log('Data posted successfully:', response);
            })
            .catch((error) => {
                console.error('Error posting data:', error);
                setIsLoading(false);
            });
    };

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const Row = ({ index, style }) => {
        const item = filteredData[index];

        return (
            <TableRow key={item.id} style={style} className={item.IsActive ? '' : 'inactiveRow'}>
                <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '3%', fontSize: '14px' }}>{index + 1}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.Code}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '45%', fontSize: '14px' }}>{item.Name}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.MRP}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.GSTRate}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>{item.HSNCode}</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #C0C0C0', height: '20px', padding: '5px', width: '10%', fontSize: '14px' }}>
                    {hasEditMasterPermission && (
                        <Link to={`/itemEdit/${item.Id}`}>
                            <IconButton color="primary">
                                <EditIcon style={{ height: '22px' }} />
                            </IconButton>
                        </Link>
                    )}
                    {hasDeleteMasterPermission && (
                        <IconButton onClick={() => openConfirmDialog(item.Id)} color="error">
                            <DeleteIcon style={{ height: '22px' }} />
                        </IconButton>
                    )}
                    {hasDeleteMasterPermission && (
                        <IconButton onClick={() => handleActivate(item.Id)} color="primary">
                            <CheckCircleIcon style={{ height: '22px' }} />
                        </IconButton>
                    )}
                </TableCell>
            </TableRow>
        );
    };

    return (
        <div className="item-index-container">
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <div className='w-full mb-2 flex'>
                    <h5 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item </h5>
                    <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                        <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                        {showSearchInput && (
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                style={{ marginLeft: '-30px', width: '200px' }}
                            />
                        )}
                    </div>


                    {hasCreateMasterPermission && roleName == "SuperAdmin" && (
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                            <Button

                                component={Link}
                                to="/ItemCreate"
                                className="linkcolor"
                                style={{ marginLeft: '8px', color: 'orangered', fontWeight: 'bolder' }}
                            >
                                <AddIcon /> CREATE NEW
                            </Button>
                        </div>
                    )}

                    {hasCreateMasterPermission && (
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                            <Button

                                onClick={openImportDialog}
                                style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }}
                            >
                                <ImportExportIcon style={{ color: 'brown', fontWeight: 'bolder' }} />IMPORT ITEM
                            </Button>
                        </div>
                    )}
                </div>
            </div>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{ backgroundColor: '#58A5B3' }}>
                        <TableRow>
                            <TableCell><span style={{ marginLeft: '-5px', color: 'white' ,fontWeight:'bolder'}}>Sl.No</span> <span style={{ marginLeft: '5px', color: 'white' ,fontWeight:'bolder'}}>Code</span>   <span style={{ marginLeft: '95px', color: 'white' ,fontWeight:'bolder'}}>Name</span>   <span style={{ marginLeft: '545px', color: 'white' ,fontWeight:'bolder'}}>MRP</span>   <span style={{ marginLeft: '95px', color: 'white',fontWeight:'bolder' }}>GST</span>  <span style={{ marginLeft: '95px', color: 'white' ,fontWeight:'bolder'}}>HSN</span>    <span style={{ marginLeft: '125px', color: 'white' ,fontWeight:'bolder'}}>Action</span> </TableCell>
                            {/* <TableCell>Code</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>MRP</TableCell>
                            <TableCell>GST</TableCell>
                            <TableCell>HSN</TableCell>
                            <TableCell>Actions</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody sx={{ backgroundColor: '#C3E9E4' }}>
                        <List
                            height={500}
                            itemCount={filteredData.length}
                            itemSize={60}
                            width="100%"
                        >
                            {Row}
                        </List>
                    </TableBody>
                </Table>
            </TableContainer>
            <Dialog open={confirmDialogOpen} onClose={closeConfirmDialog}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>Are you sure you want to delete this item?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeConfirmDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="secondary">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={importDialogOpen} onClose={closeImportDialog}>
                <DialogTitle>Import Items</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Upload an Excel file to import items. Ensure the file format is correct.
                    </DialogContentText>
                    <input type="file" onChange={handleFileChange} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeImportDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleImport} color="secondary" disabled={isLoading}>
                        {isLoading ? <CircularProgress size={24} /> : 'Import'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default ItemIndex;


